import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// The full Terms of Service body is stored per-language under the
// `termsConditions.content` key of each translation file and rendered
// generically here. Content sourced verbatim from
// "SpinSaga_Terms_and_Conditions_Crypto.docx.pdf"; the source's numbering gaps
// (e.g. the omitted 1.2 and Section 4) and bracketed placeholders like
// [Jurisdiction] are preserved as supplied. The English version prevails over
// any translation (see clause 1.4).
const renderBlock = (block, index) => {
  switch (block.type) {
    case "center-bold":
      return (
        <p key={index} style={{ textAlign: "center", fontWeight: "bold" }}>
          {block.text}
        </p>
      );
    case "h2":
      return (
        <h2 key={index} style={{ textAlign: "center" }}>
          {block.text}
        </h2>
      );
    case "h3":
      return <h3 key={index}>{block.text}</h3>;
    case "em":
      return (
        <p key={index}>
          <em>{block.text}</em>
        </p>
      );
    case "strong":
      return (
        <p key={index}>
          <strong>{block.text}</strong>
        </p>
      );
    case "p":
      return <p key={index}>{block.text}</p>;
    case "ul":
      return (
        <ul key={index}>
          {block.items.map((item, i) => (
            <li key={i}>
              {typeof item === "string" ? (
                item
              ) : (
                <>
                  <strong>{item.label}</strong> {item.text}
                </>
              )}
            </li>
          ))}
        </ul>
      );
    case "contact":
      return (
        <p key={index}>
          <strong>{block.items[0]}</strong>
          {block.items.slice(1).map((line, i) => (
            <Fragment key={i}>
              <br />
              {line}
            </Fragment>
          ))}
        </p>
      );
    default:
      return null;
  }
};

const TermCondition = () => {
  const { t } = useTranslation();
  const content = t("termsConditions.content", { returnObjects: true });
  const blocks = Array.isArray(content) ? content : [];
  return (
    <div>
      <Helmet>
        <title>{t('termsConditions.pageTitle')}</title>
        <meta name="description" content={t('termsConditions.metaDescription')} />
        <link rel="canonical" href="https://coin.spinsagacasino.com/terms-conditions/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="SpinSaga Casino" />
        <meta property="og:url" content="https://coin.spinsagacasino.com/terms-conditions/" />
        <meta property="og:title" content={t('termsConditions.pageTitle')} />
        <meta property="og:description" content={t('termsConditions.metaDescription')} />
        <meta property="og:image" content="https://coin.spinsagacasino.com/512x512.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={t('termsConditions.pageTitle')} />
        <meta name="twitter:description" content={t('termsConditions.metaDescription')} />
        <meta name="twitter:image" content="https://coin.spinsagacasino.com/512x512.png" />
      </Helmet>
      <div
        className="container bg-color-tc space-bottom content-only"
        style={{ marginTop: 80 }}
      >
        <div className="inner-smallspace-rg">
          <div className="row">
            <div className="col-md-12">
              <div className="content-page-design" style={{ padding: "20px" }}>
                {blocks.map((block, index) => renderBlock(block, index))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermCondition;
